import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";

import { sendMessageToNative } from "@/api/react-native/bridge";
import { isMobileApp } from "@/utils/platform";

interface AppInitializerProps {
  onReady?: () => void;
}

export const WebviewInitializer = ({ onReady }: AppInitializerProps) => {
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!isMobileApp()) {
      return;
    }

    const signalAppReady = () => {
      sendMessageToNative({
        type: "APP_READY",
        payload: { ready: true },
      });
      onReady?.();
    };

    let tickCount = 0;

    // Fallback: hide splash after 10s no matter what
    const maxWaitTimeout = setTimeout(() => {
      clearInterval(intervalId);
      signalAppReady();
    }, 10000);

    const intervalId = setInterval(() => {
      tickCount++;
      const isFetching = queryClient.isFetching();

      // Wait 500ms (5 ticks) for route components to mount and start queries,
      // then signal ready once no queries are actively fetching
      if (tickCount >= 5 && isFetching === 0) {
        clearInterval(intervalId);
        clearTimeout(maxWaitTimeout);
        setTimeout(signalAppReady, 200);
      }
    }, 100);

    return () => {
      clearInterval(intervalId);
      clearTimeout(maxWaitTimeout);
    };
  }, [queryClient, onReady]);

  return null;
};
